"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;
var serviceURL = "/printbridgeservice/v1/api";
var config = {
  site: serviceURL + "/standard/print-bridge/site",
  sitePb: serviceURL + "/standard/print-bridge",
  report: serviceURL + "/standard/print-bridge/report",
  printBridge: serviceURL + "/print-bridge",
  reportUpdatePb: serviceURL + "/printbridge/report/pdf",
  reportPb: serviceURL + "/printbridge/report"
};
exports.config = config;